export default __webpack_public_path__ + "static/media/ELECTIVES_BUSINESS_AND_FINANCE.8525d0ad.svg";